import logEventThenRedirect from '../actions/logEventThenRedirect';

/**
 * This function attaches click event listeners to each `.gdpr-consent-page-link`
 * that also logs the `data-ga-event` data attribute to google analytics.
 */
const attachEventTrackingToLinks = () => {
  const consentBannerContentLinks = document.querySelectorAll('.gdpr-consent-banner .gdpr-consent-page-link');

  /**
   * Attach Event Listener to each element
   */
  consentBannerContentLinks.forEach((element) => element.addEventListener('click', logEventThenRedirect));
};

export default attachEventTrackingToLinks;
